/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './authManageLabelerService.defs.js'
export { main as default } from './authManageLabelerService.defs.js'
